module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing_en.4a6e572f484946a4d7891bb59aa1e347.png";